import React from "react";

import { formatPercent } from "features/Partners/percent";
import { PartnerDto } from "services/partners/restModels";
import { formatDate } from "shared/lib/dateTime";
import { formatPhoneNumber } from "shared/lib/phoneNumber";
import { Button } from "shared/ui/Button";

import { PartnerDetailsDialog } from "../../hooks/usePartnerDetailsState";
import { Actions, InfoLabel, InfoList, InfoValue } from "../../styles";

interface PartnerInfoTabProps {
    partner: PartnerDto;
    onOpenDialog: (dialog: PartnerDetailsDialog) => void;
}

export const PartnerInfoTab = ({ partner, onOpenDialog }: PartnerInfoTabProps) => (
    <>
        <InfoList>
            <InfoLabel>Телефон аккаунта</InfoLabel>
            <InfoValue>{partner.phoneNumber ? formatPhoneNumber(partner.phoneNumber) : "—"}</InfoValue>

            <InfoLabel>Процент вознаграждения</InfoLabel>
            <InfoValue>{formatPercent(partner.commissionPercent)}</InfoValue>

            <InfoLabel>Заведений</InfoLabel>
            <InfoValue>{partner.branchesCount}</InfoValue>

            <InfoLabel>Партнёр с</InfoLabel>
            <InfoValue>{formatDate(partner.createdAt)}</InfoValue>
        </InfoList>

        <Actions>
            <Button onClick={() => onOpenDialog("edit")}>Изменить</Button>
            <Button variant="outlined" color="neutral" onClick={() => onOpenDialog("account")}>
                Сменить аккаунт
            </Button>
            <Button variant="outlined" color="danger" onClick={() => onOpenDialog("delete")}>
                Удалить
            </Button>
        </Actions>
    </>
);
